<script setup lang="ts">

defineProps({
  active: {
    type: Boolean,
    default: false
  },
  fullWidth: {
    type: Boolean,
    default: false
  }
})

</script>

<template>
<button :class="{
  'py-1 px-3 hover:bg-slate-500 rounded text-slate-300': true,
  'bg-slate-700': active,
  'bg-slate-600': !active,
  'w-full': fullWidth
}">
  <slot></slot>
</button>
</template>

<style scoped lang="scss">

</style>